import { sendEventToTestProvider } from '@noths/polaris-client-experiments';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { addItemToBasket } from 'src/redux/basket';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { generateProductFieldObject } from 'src/utils';
import { ADD_TO_BASKET_SITESPECT_EVENT, AddToBasketEvent, AddToBasketInitialEvent } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [addItemToBasket.fulfilled.type]: (state) => {
    sendEventToTestProvider(ADD_TO_BASKET_SITESPECT_EVENT);

    sendGAEvent<AddToBasketInitialEvent>({
      ecommerce: null,
    });

    sendGAEvent<AddToBasketEvent>({
      event: 'add_to_cart',
      event_action: 'Add to basket',
      event_category: 'Product page',
      event_label: null,
      ecommerce: {
        add: {
          products: [generateProductFieldObject(state)],
        },
      },
    });
  },
};
